var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentinvestigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-708 -648)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(708 648)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_527_",
    transform: "translate(719.482 657.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_331_",
    d: "M20.4,29.9,18,27.5l3.4-3.3,2.4,2.3Z",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_828_",
    d: "M20.7,29.9,18,27.2a.668.668,0,0,0-1,0L.5,43.2a.668.668,0,0,0,0,1l2.8,2.7a.668.668,0,0,0,1,0l16.5-16a.758.758,0,0,0-.1-1Z",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_827_",
    d: "M21,31.6,16.2,27a.668.668,0,0,0-1,0L.2,41.6a.668.668,0,0,0,0,1L5,47.1a.668.668,0,0,0,1,0L21,32.5A.746.746,0,0,0,21,31.6Z",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_826_",
    cx: 15.2,
    cy: 14.8,
    rx: 15.2,
    ry: 14.8,
    transform: "translate(17.6 0.7)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_829_",
    cx: 13,
    cy: 12.6,
    rx: 13,
    ry: 12.6,
    transform: "translate(19.8 2.9)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_825_",
    d: "M42.7,14.9H40.2a7.316,7.316,0,0,0-6.9-6.7V5.8a.645.645,0,0,0-.6-.6.576.576,0,0,0-.6.6V8.2a7.4,7.4,0,0,0-6.9,6.7H22.7a.576.576,0,0,0-.6.6.645.645,0,0,0,.6.6h2.5a7.4,7.4,0,0,0,6.9,6.7v2.4a.645.645,0,0,0,.6.6.576.576,0,0,0,.6-.6V22.8a7.4,7.4,0,0,0,6.9-6.7h2.5a.576.576,0,0,0,.6-.6.645.645,0,0,0-.6-.6ZM38.6,16h.5a6.3,6.3,0,0,1-5.8,5.6v-.5a.645.645,0,0,0-.6-.6.576.576,0,0,0-.6.6v.5A6.3,6.3,0,0,1,26.3,16H27a.576.576,0,0,0,.6-.6.645.645,0,0,0-.6-.6h-.5a6.3,6.3,0,0,1,5.8-5.6v.5a.645.645,0,0,0,.6.6.576.576,0,0,0,.6-.6V9.3a6.3,6.3,0,0,1,5.8,5.6h-.5a.576.576,0,0,0-.6.6c-.2.3,0,.5.4.5Z",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_830_",
    cx: 3,
    cy: 2.9,
    rx: 3,
    ry: 2.9,
    transform: "translate(29.8 12.6)",
    fill: "#494f54"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentinvestigation);
export default __webpack_public_path__ + "static/media/incidentinvestigation.d1ecca77fa226f9bd1e55baf534f24f8.svg";
export { ForwardRef as ReactComponent };